import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    headerActionWrapper: {
        display: "flex",
        alignItems: "center",
        gap: 6,
        cursor: "pointer",
    },
    headerFilterButton: {
        "& button": {
            backgroundColor: theme.palette.primary.dark,
            border: "1px solid transparent !important",
            color: `${theme.palette.primary.main} !important`,
        },
        "& button:hover": {
            backgroundColor: theme.palette.primary.dark,
            border: "1px solid transparent !important",
            color: `${theme.palette.primary.main} !important`,
        },
        "& button.Mui-selected": {
            backgroundColor: theme.palette.info.main,
        },
        "& button.Mui-selected:hover": {
            backgroundColor: theme.palette.info.main,
        },
    },
    filtersAppliedHidden: {
        "& button": {
            boxShadow: `0 0 0 2px ${theme.palette.info.main}, 0 4px 8px 0 rgba(0, 0, 0, 0.2)`,
            position: "relative",
        },
        "& button::after": {
            content: '""',
            position: "absolute",
            top: "-4px",
            right: "-4px",
            width: "8px",
            height: "8px",
            backgroundColor: theme.palette.info.main,
            borderRadius: "50%",
            border: `2px solid white`,
        },
    },
    tooltip: {
        "&.MuiTooltip-popper .MuiTooltip-tooltip": {
            backgroundColor: theme.palette.secondary.main,
        },
    },
    tooltipTexts: {
        "&.MuiTypography-root": {
            fontSize: "14px",
            textAlign: "left",
            color: theme.palette.text.primary,
            fontWeight: 600,
            fontFamily: "Open Sans",
            paddingBottom: theme.spacing(0.625),
        },
    },
}));
